import api from "@/lib/api";
import { toast } from "sonner";

/**
 * Trigger a CSV download from a protected /api/exports/* endpoint.
 * Uses axios (cookies included) to fetch the blob, then triggers a browser download.
 */
export async function downloadCsv(path, fallbackName = "export.csv") {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const filename =
      /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || fallbackName;
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    toast.success(`Downloaded ${filename}`);
  } catch (error) {
    toast.error(error.response?.status === 403 ? "You don't have permission to export" : "Export failed");
  }
}
